<template>
    <div class="d-flex">
        <div class="ml-3 mt-1">
            <template v-if="$store.state.debugMode"> #{{ resultCategory.id }} </template>
            {{ resultCategory.genderLabel() }}

            <span v-if="!resultCategory.is_elite && !resultCategory.meet.is_international">
                {{ resultCategory.age_group }}
            </span>
        </div>

        <live-indicator v-if="liveResultCategoryIds.includes(resultCategory.id)" class="mt-2" />
    </div>
</template>

<script>
import ResultCategory from '@/Models/ResultCategory.js';
import LiveIndicator from '@/Components/LiveIndicator.vue';

export default {
    name: 'LevelResult',

    components: { LiveIndicator },

    props: {
        resultCategory: {
            type: ResultCategory,
            required: true,
        },

        liveResultCategoryIds: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
};
</script>
